import { ListType } from 'modules/domains';
import { Tab } from 'ui/tabs';
import { TabsGroup } from 'ui/tabsGroup';
import { useTranslation } from 'modules/domains/list';

import { useFiltersContext } from '../../contexts';

export const PrimaryFilters = () => {
  const { t } = useTranslation();
  const { types, setTypes } = useFiltersContext();
  // we want to show ALL tab whenever no types are selected or more than one type is selected
  const isAllSelected = types.length !== 1;

  const tabs = Object.values(ListType).map((listTypeId) => {
    const isSelected = types.length === 1 && types[0] === listTypeId;
    return (
      <Tab
        isSelected={isSelected}
        id={ListType.Standard}
        key={listTypeId}
        onClick={() => setTypes([listTypeId])}
      >
        {t(`indexPage.listTypes.${listTypeId}`)}
      </Tab>
    );
  });

  return (
    <div data-test="primary-filters">
      <TabsGroup>
        <Tab isSelected={isAllSelected} id="All" onClick={() => setTypes([])}>
          {t('indexPage.listTypes.All')}
        </Tab>
        {tabs}
      </TabsGroup>
    </div>
  );
};
